import React, { ReactElement, ComponentType } from 'react';

export class ErrorBoundary extends React.Component<{
  FallbackComponent: ReactElement;
  children: ReactElement;
}> {
  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error };
  }

  state: { error: null | Error } = { error: null };

  render(): ReactElement {
    const { error } = this.state;

    const { FallbackComponent } = this.props;

    if (error !== null) {
      return FallbackComponent;
    }

    return this.props.children;
  }
}
